import styled from 'styled-components'
import { Modal } from '@77sol/core'

export const StyledModal = styled(Modal)`
  padding: 0 !important;
  background-color: white;
`
